<section class="l-reset">
  <div class="reset">
    <div class="reset-body" *ngIf="verified && isRequestFinished">
      <div class="reset-cover">
        <img src="/assets/images/auth/no-email.png" alt="" class="image" />
      </div>
      <div class="reset-title">
        {{ "Email verified" | translate }}
      </div>
    </div>

    <ng-container *ngIf="!verified && isRequestFinished">
      <div class="reset-body">
        <div class="reset-cover">
          <img
            src="/assets/images/auth/header-type-user.png"
            alt=""
            class="image"
          />
        </div>
        <div class="reset-title">
          {{ errorMsg || "error occured" | translate }}
        </div>
        <button
          routerLink="/"
          type="button"
          class="btn w-100 mb-3"
          style="background-color: #0b2027; color: white"
        >
          {{ "Go back" | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</section>
